import { setAppId, setContextMenuPosition, updateCustomLogics, updateDatasets, updatePermissions, updateStates, updateViews, } from './reducer';
export var setAppIdAction = function (appId) { return function (dispatch) {
    dispatch(setAppId(appId));
}; };
export var updateDatasetsAction = function (datasets) {
    if (datasets === void 0) { datasets = []; }
    return function (dispatch) {
        dispatch(updateDatasets(datasets));
    };
};
export var updateStatesAction = function (states) {
    if (states === void 0) { states = []; }
    return function (dispatch) {
        dispatch(updateStates(states));
    };
};
export var updateViewsAction = function (views) {
    if (views === void 0) { views = []; }
    return function (dispatch) {
        dispatch(updateViews(views));
    };
};
export var updateCustomLogicsAction = function (customLogics) {
    if (customLogics === void 0) { customLogics = []; }
    return function (dispatch) {
        dispatch(updateCustomLogics(customLogics));
    };
};
export var updatePermissionsAction = function (permissions) {
    if (permissions === void 0) { permissions = []; }
    return function (dispatch) {
        dispatch(updatePermissions(permissions));
    };
};
export var setContextMenuPositionAction = function (position) { return function (dispatch) {
    dispatch(setContextMenuPosition(position));
}; };
